import FJLocalStore from '../../../store/FJLocalStore';
import FJCategoryItemSeeAll from './FJCategoryItemSeeAll';
import styles from './FJCategoryItemHeader.module.less';
import PropTypes from 'prop-types';
/**
 * @desc 分类列表标题 Header
 * @returns
 */
const FJCategoryItemHeader = props => {
    const { seeAll, title, isShowSeeAll = true, style, renderIcon = () => {} } = props;

    return (
        <div className={styles.header} style={style}>
            <div className={styles.title}>
                {FJLocalStore._(title)}
                {renderIcon()}
            </div>
            {isShowSeeAll && <FJCategoryItemSeeAll seeAll={seeAll} isShowSeeAll={isShowSeeAll} />}
        </div>
    );
};
FJCategoryItemHeader.propTypes = {
    seeAll: PropTypes.func,
    title: PropTypes.string.isRequired,
    isShowSeeAll: PropTypes.bool,
    style: PropTypes.object,
    renderIcon: PropTypes.func,
};

export default FJCategoryItemHeader;
